/** @jsx isolateComponent */
import { css } from '@emotion/react';
import { Animation, Icon } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';

const Styles = labelStyles('Arrow', {
  root: css({
    opacity: 0,
    height: 16,
    marginLeft: 0,
    marginTop: 2,
    position: 'absolute',
    transition: `opacity 100ms ${Animation.transitionTimingFunction}, margin 150ms ${Animation.transitionTimingFunction}`,
  }),
});

/**
 * @private
 * Indicator arrow for when links are hovered
 */
export const ArrowLinkIcon = () => (
  <span css={Styles.root} data-tag="arrow-icon-wrapper">
    <Icon name="arrowBigRight" size={14} />
  </span>
);
